require.register("attachment/controllers/bulkCtrl", function(exports, require, module){
  $0
  
});

